/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the refund - maps to Ping Payments RefundStatus
 * @export
 */
export const WebApiModelsEnumerationTypesPaymentRefundStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type WebApiModelsEnumerationTypesPaymentRefundStatus = typeof WebApiModelsEnumerationTypesPaymentRefundStatus[keyof typeof WebApiModelsEnumerationTypesPaymentRefundStatus];


export function WebApiModelsEnumerationTypesPaymentRefundStatusFromJSON(json: any): WebApiModelsEnumerationTypesPaymentRefundStatus {
    return WebApiModelsEnumerationTypesPaymentRefundStatusFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesPaymentRefundStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesPaymentRefundStatus {
    return json as WebApiModelsEnumerationTypesPaymentRefundStatus;
}

export function WebApiModelsEnumerationTypesPaymentRefundStatusToJSON(value?: WebApiModelsEnumerationTypesPaymentRefundStatus | null): any {
    return value as any;
}

